import React, { useMemo, useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import NtDevider from "./NtDevider";
import NtMaterialIcon from "./NtMaterialIcon";
import NtTouchableEffect from "./NtTouchableEffect";
import NtModal from "./NtModal";
import NtListHeaderColumnPicker from "./NtListHeaderColumnPicker";
import NtListHeaderExportModal from "./NtListHeaderExportModal";
import { useTheme } from "../context/ThemeContext";

function NtListHeader({
  containerStyle,
  headerContainerStyle,
  headerTextStyle,
  selectedColumns,
  columns,
  onColumnUpdate,
  visible = true,
  overideColumnName = [],

  //export
  exportFileName,
  exportDataParser,
  exportFetchDataAsync,
}) {
  const fieldsSelectRef = useRef();
  const exportModalRef = useRef();
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const renderRow = (item) => {
    const override = overideColumnName?.find((each) => each.id == item.id);

    return (
      <View
        style={{ flex: 1, alignItems: "flex-start", justifyContent: "center" }}
        key={item.title}
      >
        <NtText style={[styles.text, headerTextStyle]}>
          {override?.title || item.title}
        </NtText>
      </View>
    );
  };

  const renderFieldsSelectModal = () => {
    return (
      <NtModal ref={fieldsSelectRef}>
        <NtListHeaderColumnPicker
          onCancel={() => {
            fieldsSelectRef.current?.dismiss();
          }}
          overideColumnName={overideColumnName}
          selectedColumns={selectedColumns}
          columns={columns}
          onUpdate={(selected) => {
            if (onColumnUpdate) {
              onColumnUpdate(selected);
            }
            fieldsSelectRef.current?.dismiss();
          }}
        />
      </NtModal>
    );
  };

  const renderExportModal = () => {
    return (
      <NtModal ref={exportModalRef}>
        <NtListHeaderExportModal
          onCancel={() => {
            exportModalRef.current?.dismiss();
          }}
          overideColumnName={overideColumnName}
          selectedColumns={selectedColumns}
          columns={columns}
          onExported={() => {
            exportModalRef.current?.dismiss();
          }}
          exportFileName={exportFileName}
          exportDataParser={exportDataParser}
          exportFetchDataAsync={exportFetchDataAsync}
        />
      </NtModal>
    );
  };

  const renderButton = (icon, title, onPress, containerStyle) => {
    return (
      <NtTouchableEffect
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            borderColor: theme.border,
            borderWidth: 1,
            borderRadius: theme.radius,
            padding: 3,
            paddingLeft: 8,
            paddingRight: 8,
            backgroundColor: theme.surface,
          },
          containerStyle,
        ]}
        onPress={onPress}
      >
        <NtMaterialIcon name={icon} color={theme.textDim} size={14} />
        <NtText
          style={{
            color: theme.text,
            fontWeight: "600",
            fontSize: 11,
            marginLeft: 4,
          }}
        >
          {title}
        </NtText>
      </NtTouchableEffect>
    );
  };

  if (!visible) {
    return true;
  }

  return (
    <View style={[styles.container, containerStyle]}>
      <View
        style={{
          alignItems: "flex-end",
          marginBottom: 10,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          {exportFileName &&
            exportFetchDataAsync &&
            renderButton(
              "download",
              "Export Data",
              () => {
                exportModalRef.current?.show();
              },
              {
                marginRight: 15,
              }
            )}

          {columns &&
            renderButton("cog", "Manage Columns", () => {
              fieldsSelectRef.current?.show();
            })}
        </View>
      </View>

      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            paddingTop: 10,
            paddingBottom: 10,
          },
          headerContainerStyle,
        ]}
      >
        {selectedColumns?.map((each) => renderRow(each))}
      </View>
      <NtDevider />
      {renderFieldsSelectModal()}
      {renderExportModal()}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {},
    text: {
      fontSize: 11,
      fontWeight: "600",
      color: t.textMute,
      textTransform: "uppercase",
      letterSpacing: 0.4,
    },
  });

export default NtListHeader;
